import { isObj } from '../../../shared/misc';
import { takeData } from '../../../shared/misc/api-utils';

export const fetchCore = async () => {
  // Still here for node server deploys.
  // At some point we should remove this line.
  if (isObj(window.vmRevolutionCoreValue)) return window.vmRevolutionCoreValue;

  const url = new URL(window.location.origin);
  url.pathname = 'coreSettings.json';

  return fetch(url).then(takeData);
};
